import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const SystemUserService = {
  login: (email: string, password: string) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}auth/login`, { email, password });
  },
  forgotPassword: (email: string) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}auth/forgot-password`, { email });
  },
  changePassword: (
    _id: string,
    password: string,
    token: string
  ) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}auth/change-password`, { _id, password, token });
  },
  save: (data: {
    email: string,
    name: string,
    role: string,
  }) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}system-users/save`, { ...data, account });
  },
  list: (acc?: string) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}system-users/${acc ? acc : account}`);
  },
  handleStatus: (_id: string, status: boolean) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}system-users/handle-status`, { _id, status });
  },
}